import type { PreviewManagementFiltersFormProps } from './types'

export const initialFormValues: PreviewManagementFiltersFormProps = {
  businessUnit: '',
  directorate: [],
  portfolio: [],
  economicGroup: [],
  segment: [],
  serviceType: [],
  goName: [],
  gceName: []
}
